const { assert } = require('../common/assert');

class XYCircle {
  constructor({ cx, cy, r, z }) {
    assert(Number.isFinite(cx), 'cx must be a number');
    assert(Number.isFinite(cy), 'cy must be a number');
    assert(Number.isFinite(z), 'z must be a number');
    assert(r >= 0, 'r must be greater than or equal to 0');
    this.cx = cx;
    this.cy = cy;
    this.r = r;
    this.z = z;
  }

  boundingRect() {
    return {
      minX: this.cx - this.r,
      minY: this.cy - this.r,
      maxX: this.cx + this.r,
      maxY: this.cy + this.r,
    };
  }

  fullyContains(otherCircle) {
    assert(otherCircle instanceof XYCircle, 'otherCircle must be an instance of XYCircle');
    const distanceBetweenCentres = Math.sqrt(
      (this.cx - otherCircle.cx) ** 2 + (this.cy - otherCircle.cy) ** 2,
    );
    return distanceBetweenCentres + otherCircle.r <= this.r;
  }

  containsPoint(x, y) {
    return Math.sqrt((x - this.cx) ** 2 + (y - this.cy) ** 2) <= this.r;
  }
}

class XYRectangle {
  constructor({ x1, y1, x2, y2, z }) {
    assert(Number.isFinite(x1), 'x1 must be a number');
    assert(Number.isFinite(x2) && x2 > x1, 'x2 must be a number > x1');
    assert(Number.isFinite(y1), 'y1 must be a number');
    assert(Number.isFinite(y2) && y2 > y1, 'y2 must be a number > y1');
    assert(Number.isFinite(z), 'z must be a number');

    this.x1 = x1;
    this.y1 = y1;
    this.x2 = x2;
    this.y2 = y2;
    this.z = z;
  }

  boundingRect() {
    return {
      minX: this.x1,
      minY: this.y1,
      maxX: this.x2,
      maxY: this.y2,
    };
  }

  fullyContains(otherRectangle) {
    assert(otherRectangle instanceof XYRectangle, 'otherRectangle must be an instance of XYRectangle');
    return this.x1 <= otherRectangle.x1 &&
      this.y1 <= otherRectangle.y1 &&
      this.x2 >= otherRectangle.x2 &&
      this.y2 >= otherRectangle.y2;
  }

  containsPoint(x, y) {
    return x >= this.x1 && x <= this.x2 && y >= this.y1 && y <= this.y2;
  }
}

exports.XYRectangle = XYRectangle;
exports.XYCircle = XYCircle;
